import EventHandler from '@pixelunion/events';
import * as breakpoint from '@pixelunion/breakpoint';
import Flickity from 'flickity-fade';
import 'flickity-as-nav-for';
import 'flickity-sync';

export default class Testimonial {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;

    this.testimonial = this.el.querySelector('[data-testimonial-slideshow]');
    this.testimonialInfo = this.el.querySelector('[data-slideshow-secondary]');
    this.testimonialSlides = this.testimonial.querySelectorAll('[data-slide]');

    this._onChange = this._onChange.bind(this);

    this.events = new EventHandler();
    breakpoint.onChange(this._onChange);

    this._setupFlickity();
  }

  _showPageDots() {
    if (this.testimonialSlides.length <= 1) {
      return false;
    }

    if (this.settings.desktop_navigation_style === 'dots' || breakpoint.max('S')) {
      return true;
    }

    return false;
  }

  _setupFlickity() {
    const pageDots = this._showPageDots();
    const supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    const slideshowSettings = {
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 65,
        y2: 45,
        x3: 20,
      },
      fade: true,
      friction: 0.5,
      wrapAround: true,
      selectedAttraction: 0.075,
      adaptiveHeight: true,
      draggable: supportsTouch,
      cellSelector: '[data-slide]',
      prevNextButtons: this.settings.desktop_navigation_style === 'buttons',
      pageDots: false,
    };

    const secondarySlideshowSettings = {
      asNavFor: this.testimonial,
      wrapAround: this.testimonialSlides.length > 2,
      friction: 0.5,
      selectedAttraction: 0.075,
      adaptiveHeight: false,
      prevNextButtons: false,
      freeScroll: false,
      draggable: supportsTouch,
      cellSelector: '[data-secondary-slide]',
      pageDots,
      sync: this.testimonial,
    };

    this.testimonialSlideshow = new Flickity(this.testimonial, slideshowSettings);
    this.secondarySlideshow = new Flickity(this.testimonialInfo, secondarySlideshowSettings);

    this.events.register(this.testimonialInfo, 'rimg:load', () => {
      this.secondarySlideshow.resize();
    });

    // Remove the aria-hidden attribute as the images should be focusable/accessible via keyboard
    this.secondarySlideshow.on('select', (index) => {
      for (let i = 0; i < this.secondarySlideshow.cells.length; i++) {
        if (i !== index) {
          this.secondarySlideshow.cells[i].element.ariaHidden = null;
        }
      }
    })
  }

  _onChange(event) {
    this._reconstructFlickity();
  }

  _reconstructFlickity() {
    this.testimonialSlideshow.destroy();
    this.secondarySlideshow.destroy();
    this.events.unregisterAll();

    this._setupFlickity();
  }

  onSectionBlockSelect(block) {
    const { slideIndex } = block.el.dataset;
    this.testimonialSlideshow.select(slideIndex);
  }

  onSectionBlockDeselect() {
  }

  onSectionUnload() {
    this.testimonialSlideshow.destroy();
    this.secondarySlideshow.destroy();
    this.events.unregisterAll();
    breakpoint.offChange(this._onChange);
  }
}
